import PropTypes from 'prop-types';
import styled from 'styled-components';
import React, { PureComponent } from 'react';
import colors from '@theme/colors';
import GlobalSnackbar from '@atoms/GlobalSnackbar';

const StyledPage = styled.div`
  background-color: ${colors.LIGHT_GREY};
`;

export const Container = styled.div`
  text-align: -webkit-center;
`;

export const Title = styled.h1`
  text-align: center;
  color: ${colors.INTENSIVE};
  font-size: 26px;
  font-weight: 400;
`;

export default class BasicPage extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
  };

  static defaultProps = {
    className: null,
  };

  render() {
    return (
      <StyledPage className={this.props.className}>
        {this.props.children}
        <GlobalSnackbar />
      </StyledPage>
    );
  }
}



// WEBPACK FOOTER //
// ./components/layout/BasicPage.js